import { PlanVisibilitySettings } from '../../models/plan-visibility-settings'

export abstract class PlanVisibilitySettingsDao {
  public abstract findOne(id: number): Promise<PlanVisibilitySettings | undefined>

  public abstract update(planVisibilitySettings: PlanVisibilitySettings): Promise<void>
}
